import { destroy, mutate, query, update } from "../../defaults/fetch";
import { useEffect,useState } from "react";


export const useCreateDepartment = ()=>{
    const createFaculty = async (body)=>{
        const url = `department/create`;
        const {message} = await mutate(url,true,body);
        return message;
    }
    return createFaculty;
}


export const useDepartments = (flag)=>{
    const [departments,setDepartments] = useState([]);
    const [loading,setLoading] = useState(false);

    const getDepartments = async ()=>{
        setLoading(true);
        const url = `department/get-all`;
        const {data} = await query(url)
        setLoading(false);
        setDepartments(data);
    }

    useEffect(()=>{
        getDepartments()
    },[flag])
 
    return {loading,departments};
}

export const useUpdateDepartment = ()=>{
    const updateDepartment = async (id,body)=>{
        const url = `department/update/${id}`;
        const {message} = await update(url,body);
        return message;
    }

    return updateDepartment;
}

export const useDeleteDepartment = ()=>{
    const deleteDepartment = async (id)=>{
        const url = `department/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deleteDepartment;
}